import utils from './utils';
import paths from './paths';

export default {
  ...utils,
  ...paths,
};
